{
	"type": "line",
	"minzoom": 7,
	"layout": {
		"line-cap": "round"
	},
	"paint": {
		"line-color": ["match", ["get", "slr_type"], "Enforce", "#4f2bd1", "Lower", "#a22bd1", "#ddd"],
		"line-width": ["interpolate", ["linear"], ["zoom"], 9, 2, 18, 9],
		"line-opacity": ["step", ["zoom"], ["case", ["get", "all_zoom_levels"], 1, 0], 11, 1]
	}
}
